const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/mypageAccess');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getByBrand(brand) {
    const capitilizeMake = brand.charAt(0).toUpperCase() + brand.slice(1);
    const extId = `mgms${capitilizeMake}Login`;

    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'configuration', // eslint-disable-line
        'fields.id': extId,
        'limit': 1
      }).catch(
        processError
      ).then((entries) => {
        return transformer.contentfulToInternal(entries.items[0]);
      });
    });
  },

  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  save(...parameters) {
    return gettingEntryService().then((service) => service.save(...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  }
};
